import * as React from 'react';
import { Tree, TreeItem, TreeItemLayout } from '@fluentui/react-components';
import VisitConceptTypeBadge, { VisitConceptNodeKind } from '../Atom/VisitConceptTypeBadge';

interface VisitConceptTreeBranchProps {
  value: string;
  kind: VisitConceptNodeKind;
  /** Nombre del tipo para la insignia (accesible). */
  kindLabel: string;
  title: React.ReactNode;
  /** Texto secundario después del título, separado con "·". */
  secondary?: React.ReactNode;
  /** Lado derecho: contadores y pastillas. */
  aside?: React.ReactNode;
  /** Resaltado en negrita (p. ej. formulario con conceptos realizados). */
  strong?: boolean;
  active?: boolean;
  onActivate?: (value: string) => void;
  children?: React.ReactNode;
  testId?: string;
}

/** Nodo rama del árbol: insignia por tipo, título, secundario y contadores a la derecha. */
const VisitConceptTreeBranch: React.FC<VisitConceptTreeBranchProps> = ({
  value,
  kind,
  kindLabel,
  title,
  secondary,
  aside,
  strong,
  active,
  onActivate,
  children,
  testId,
}) => (
  <TreeItem itemType="branch" value={value} data-testid={testId}>
    <TreeItemLayout
      iconBefore={<VisitConceptTypeBadge kind={kind} label={kindLabel} />}
      aside={aside ? <span className="vct-aside">{aside}</span> : undefined}
      data-active={active ? 'true' : undefined}
      onClick={() => onActivate?.(value)}
    >
      <span className="vct-node">
        <span className={`vct-node__title${strong ? ' vct-node__title--strong' : ''}`}>{title}</span>
        {secondary && <span className="vct-node__secondary">{secondary}</span>}
      </span>
    </TreeItemLayout>
    <Tree>{children}</Tree>
  </TreeItem>
);

export default VisitConceptTreeBranch;
